import {ActionButton} from '../Button/ActionButton'
import {Modal, ModalStateProps} from '../Modal/Modal'

const MailIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h64v64H0z" />
      <path
        d="M54 36v10a8 8 0 0 1-8 8H14a8 8 0 0 1-8-8V26a8 8 0 0 1 8-8h20m5.164 13.752L30 40 10 22"
        stroke="#FFF"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M50 8c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12c-.007-6.625-5.375-11.993-12-12zm5.268 9.884-6.461 6.461a.923.923 0 0 1-1.306 0l-2.77-2.769a.924.924 0 1 1 1.307-1.306l2.116 2.117 5.808-5.81a.924.924 0 1 1 1.306 1.307z"
        fill="#FFF"
        fill-rule="nonzero"
      />
    </g>
  </svg>
)

interface ThanksModalProps extends ModalStateProps {
  isGrillQuiz?: boolean
}

export const ThanksModal = ({isOpen, onClose, isGrillQuiz = false}: ThanksModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      id="reg-success-modal"
      overlayColor={isGrillQuiz ? 'rgba(38, 56, 67, 0.66)' : undefined}
      bgColor={isGrillQuiz ? '#040100' : undefined}
    >
      <div className="mt-8 flex justify-center">
        <MailIcon />
      </div>
      <div id="reg-thanks-text" className="mb-8 mt-4 text-center text-[40px] uppercase text-white">
        Takk for påmelding!
      </div>
      <ActionButton
        id="reg-go-back-btn"
        color={isGrillQuiz ? 'orange' : 'purple'}
        className="bg-red w-full"
        onClick={onClose}
      >
        Gå tilbake
      </ActionButton>
    </Modal>
  )
}
